module.exports = __webpack_public_path__ + "static/img/3-6.6.5.205a915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/5/3-6.6.5.png
// module id = N7K2
// module chunks = 0